import React, { useMemo, useState } from "react";
import { Segmented, Row, Button, Col, Card } from "antd";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import _ from "lodash";
import ProductDisplayComponent from "./sections/productDisplay";
import ProductTipsComponent from "./sections/productTips";
import YourNotesComponent from "./sections/yourNotes";
import DaySelector from "../day-selector/DaySelector";
import { useAppSelector } from "../../hooks/reduxHooks";
import { useFilteredProducts } from "../../hooks/useFilteredProduct";
import EmailReminder from "./sections/emailReminder";

interface SkncareStepsComponentInterface {
  data?: any;
  tips?: string;
  note?: string;
}

const getTodayName = () => {
  return new Date().toLocaleDateString("en-US", { weekday: "long" });
};

const SkncareStepsComponent: React.FC<SkncareStepsComponentInterface> = (
  props
) => {
  const [morningActiveDay, setMorningActiveDay] = useState(getTodayName);
  const [nightActiveDay, setNightActiveDay] = useState(getTodayName);

  const navigate = useNavigate();

  const { data, tips, note } = props;

  const handleMorningDayChange = (day: string) => {
    setMorningActiveDay(day);
  };

  const handleNightDayChange = (day: string) => {
    setNightActiveDay(day);
  };

  const filteredMorningProducts = useFilteredProducts(
    data?.morning,
    morningActiveDay
  );
  const filteredNightProducts = useFilteredProducts(
    data?.night,
    nightActiveDay
  );

  // const stepsMorningProduct = _.filter(data?.morning, ["dont_use", false]);

  // const stepNightProducts = _.filter(data?.night, ["dont_use", false]);

  const profile = useAppSelector((state) => state.profile);
  const { name, first_name } = profile;

  return (
    <section className="store-section skincare-steps">
      <div className="routine">
        <Card>
          <div className="skincare-steps__flex">
            <DaySelector
              onDayChange={handleMorningDayChange}
              initialDay={morningActiveDay}
            />
            <div className="skincare-steps__flex-right">
              <div className="title-wrapper">
                <h1 className="title store-card__title trac-title">
                  {first_name}'s Morning ☀️ Skincare Steps
                </h1>
              </div>
              <Row className="routine__products">
                {filteredMorningProducts.length > 0 ? (
                  <ProductDisplayComponent data={filteredMorningProducts} />
                ) : null}
              </Row>
            </div>
          </div>
        </Card>
        <Card>
          <div className="skincare-steps__flex  skincare-steps__night">
            <DaySelector
              onDayChange={handleNightDayChange}
              initialDay={nightActiveDay}
            />
            <div className="skincare-steps__flex-right">
              <h1 className="title store-card__title trac-title">
                {first_name}’s Night 🌙 Skincare Steps
              </h1>
              <Row className="routine__products">
                {filteredNightProducts.length > 0 ? (
                  <ProductDisplayComponent
                    data={filteredNightProducts}
                    isNight={true}
                  />
                ) : null}
              </Row>
            </div>
          </div>
        </Card>
        {/* <div className="routine__section">
          <div className="routine__header">
            <h1>Your Skincare Steps</h1>
          </div>
          <div className="routine__segments">
            <Segmented
              block
              options={routines}
              value={value}
              onChange={setValue}
              className={`active-selection ${
                value === "Night" ? "nightSelection" : "morningSelection"
              }`}
            />
          </div>
          <Row className="routine__products">
            {value === routines[0] ? (
              stepsMorningProduct.length > 0 ? (
                <ProductDisplayComponent data={stepsMorningProduct} />
              ) : null
            ) : stepNightProducts.length > 0 ? (
              <ProductDisplayComponent
                data={stepNightProducts}
                isNight={true}
              />
            ) : null}
          </Row>
        </div> */}
        <Row gutter={30} className="skincare-steps__tips-note-row">
          {tips ? (
            <Col span={12} xs={24} sm={24} md={12}>
              <ProductTipsComponent tips={tips} />
            </Col>
          ) : null}
          {note ? (
            <Col span={12} xs={24} sm={24} md={12}>
              <YourNotesComponent note={note} />
            </Col>
          ) : null}
        </Row>

        {/* <div className="end-button">
          <Button
            type="primary"
            danger
            onClick={() => {
                navigate("/store/skincare-steps");
              ReactGA.event({
                category: "Store",
                action: `Goto Missing Skincare button clicked -> Skincare steps`,
                label: "",
                nonInteraction: true, // optional, true/false
                transport: "xhr",
              });
              navigate("/store/#");
              // window.open(homeBaseUrl)
            }}
            className="btn-primary"
          >
            Go to Skincare Tracker
          </Button>
        </div> */}
        <EmailReminder />
        <div className="footer-cta">
          <Button
            className="btn-primary cta-btn"
            onClick={() => {
              navigate("/store/revise-routine");
              ReactGA.event({
                category: "Store",
                action: `Go to Holistic Care button clicked`,
                label: "",
                nonInteraction: true,
                transport: "xhr",
              });
            }}
          >
            Go to Revise Routine
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SkncareStepsComponent;
